import { render, staticRenderFns } from "./payrollPerms.vue?vue&type=template&id=d85753de"
import script from "./payrollPerms.vue?vue&type=script&lang=js"
export * from "./payrollPerms.vue?vue&type=script&lang=js"
import style0 from "./payrollPerms.vue?vue&type=style&index=0&id=d85753de&prod&lang=css"
import style1 from "./payrollPerms.vue?vue&type=style&index=1&id=d85753de&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports